// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"36d835af","194":"ffc36f55","377":"a80a193d","387":"da0b5d41","475":"ce38f13b","492":"1eb823aa","593":"981efc30","655":"67347b6b","693":"939d80ae","928":"33e6bdc1","986":"8d89efd8"}[chunkId] + ".chunk.js";
};